module.exports = __webpack_public_path__ + "images/card-diners.836f125e35dd07775aa89f7af3d0185b.svg";